import { NotificationTemplatesResponseModel } from "../pages/shared/models/api/notificaiotn-templates-response.model";
import { NotificationTemplate } from "../redux/reducers/user-notifications.reducer";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getNotificationTemplates(filter: object) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .post(`${API_URL}/notification/templates`, filter, authorizationHeader)
      .then((response) => response?.data as NotificationTemplatesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

async function getMyNotificationConfigs() {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .get(`${API_URL}/user-notification-configs/my`, authorizationHeader)
      .then((response) => response?.data as NotificationTemplate[]);
  } catch (error) {
    console.error(error);
  }
}

async function getNotificationConfigs(userId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .get(
        `${API_URL}/user-notification-configs/${userId}`,
        authorizationHeader,
      )
      .then((response) => response?.data as NotificationTemplate[]);
  } catch (error) {
    console.error(error);
  }
}

async function updateMyNotificationConfigs(templates: NotificationTemplate[]) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const templateIds = templates.map(
      (template) => template.notificationTemplateId,
    );

    return axiosInstance
      .put(
        `${API_URL}/user-notification-configs/update`,
        { templateIds },
        authorizationHeader,
      )
      .then((response) => response?.data as NotificationTemplatesResponseModel);
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getNotificationTemplates,
  getMyNotificationConfigs,
  getNotificationConfigs,
  updateMyNotificationConfigs,
};
